import type { Prices } from "./pricing-context"

export const PLAN_PRICES: Prices = {
	free: {
		monthly: "$0.00",
		yearly: "$0.00",
	},
	starter: {
		monthly: "$35.00",
		yearly: "$29.00",
	},
	pro: {
		monthly: "$79.00",
		yearly: "$59.00",
	},
	scale: {
		monthly: "$129.00",
		yearly: "$99.00",
	},
	business: {
		monthly: "$99.00",
		yearly: "$89.00",
	},
	enterprise: {
		monthly: "Custom",
		yearly: "Custom",
	},
}
